import React from 'react';
import { useGetIdentity } from 'react-admin';
import Parse from 'parse';
import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';

export const AccountInfo = () => {
  const { isPending } = useGetIdentity();
  const currentUser = Parse.User.current();

  const formatDate = (isoDate) => {
    const date = isoDate ? new Date(isoDate) : null;
    return date && !isNaN(date.getTime())
      ? new Intl.DateTimeFormat('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        }).format(date)
      : 'N/A';
  };

  const rawData = [
    {
      id: 1,
      name: 'Date Joined',
      value: formatDate(currentUser?.get('createdAt')),
      icon: '/Assets/Icons/calendar.svg'
    },
    {
      id: 2,
      name: 'Last Login',
      value: formatDate(currentUser?.get('lastLogin')),
      icon: '/Assets/Icons/login.svg'
    },
    {
      id: 3,
      name: 'Total Logins',
      value: currentUser?.get('loginTimes') || 0,
      icon: '/Assets/Icons/trend.svg'
    },
    {
      id: 4,
      name: 'Permissions',
      value: 'Full Access',
      icon: '/Assets/Icons/permissions.svg'
    }
  ];

  return (
    <React.Fragment>
      {isPending ? (
        <Card
          variant="outlined"
          sx={{
            backgroundColor: '#242424',
            borderRadius: '8px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          <CardContent>
            <Skeleton
              width="100%"
              height={100}
              sx={{ mt: 1, bgcolor: 'rgba(255, 255, 255, 0.1)' }}
            />
            <Skeleton width="50%" height={40} sx={{ mt: 1, bgcolor: 'rgba(255, 255, 255, 0.1)' }} />
            <Skeleton width="50%" height={40} sx={{ mt: 1, bgcolor: 'rgba(255, 255, 255, 0.1)' }} />
            <Skeleton width="50%" height={40} sx={{ mt: 1, bgcolor: 'rgba(255, 255, 255, 0.1)' }} />
          </CardContent>
        </Card>
      ) : (
        <Card
          variant="outlined"
          sx={{
            backgroundColor: '#242424',
            borderRadius: '8px',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <CardContent sx={{ flexGrow: 1 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: '#FFF',
                  fontSize: 18,
                  fontWeight: 500
                }}
              >
                Account Details
              </Typography>
              <Box
                sx={{
                  backgroundColor: 'rgba(255, 215, 0, 0.20)',
                  padding: '8px',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  src="/Assets/Icons/user-account.svg"
                  alt="User Account"
                  style={{ width: 24, height: 24 }}
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '23px'
              }}
            >
              {rawData?.map((ele, index) => (
                <Box key={ele.id}>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#999',
                      fontSize: 14,
                      fontWeight: 400,
                      mt: index === 0 ? 2 : 0
                    }}
                  >
                    {ele?.name}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <img src={ele?.icon} alt={ele?.name} style={{ width: 18, height: 18 }} />
                    <Typography
                      variant="span"
                      sx={{
                        color: '#fff',
                        fontSize: 14,
                        fontWeight: 400,
                        ml: 1
                      }}
                    >
                      {ele?.value}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </CardContent>
        </Card>
      )}
    </React.Fragment>
  );
};
